module.exports = __webpack_public_path__ + "static/media/image-26.3b6ffd15.png";